<script lang="ts" setup>
import { defineProps, withDefaults } from "vue";
import { type RouteLocationRaw, useRouter } from "vue-router";
import type { ButtonVariant } from "@/types/props";

const router = useRouter();

const props = withDefaults(
  defineProps<{
    id?: string;
    color?: string;
    to: RouteLocationRaw;
    disabled?: boolean;
    variant?: ButtonVariant;
  }>(),
  {
    color: "primary",
    disabled: false,
    variant: "flat",
  },
);

const click = () => {
  router.push(props.to);
};
</script>

<template>
  <v-btn
    :id="props.id"
    :color="props.color"
    :disabled="disabled"
    :variant="variant"
    class="text-uppercase"
    flat
    @click="click"
  >
    <slot></slot>
  </v-btn>
</template>

<style lang="scss" scoped></style>
